<template>
    <!-- <div class=""> -->
        <!-- <div class="megamenu-overlay" data-megamenu-id="2086913398243511"></div> -->
        <section class="off-canvas-nav-megamenu active">
          <nav class="offcanvas-mainnav">
            <button class="off-canvas-button-megamenu" @click="$emit('close')">
              <span class="off-canvas-nav"></span>Close
            </button>
      
            <ul class="nav navbar-nav megamenu horizontal">
              <!-- Home Dropdown -->
              <li class="nav-item dropdown active">
                <NuxtLink to="/" class="nav-link dropdown-toggle has-category" @click="$emit('close')">
                  <span class="menu-title">Home</span>
                </NuxtLink>
                <!-- <div class="dropdown-menu level1">
                  <ul>
                    <li v-for="n in 8" :key="n" class="nav-item">
                      <NuxtLink
                        :to="`/home-0${n}.html`"
                        class="nav-link"
                      >
                        <span class="menu-title">Home 0{{ n }}</span>
                      </NuxtLink>
                    </li>
                  </ul>
                </div> -->
              </li>
      
              <!-- Shop Dropdown (3 Columns) -->
              <li class="nav-item dropdown aligned-fullwidth">
                <NuxtLink to="/products" class="nav-link dropdown-toggle has-category" @click="$emit('close')">
                  <span class="menu-title">Products</span>
                </NuxtLink>
                <!-- <div class="dropdown-menu wide-menu">
                  <div class="row">
                    <MenuColumn title="Board And Display Equipment" :items="shopMenu.boardAndDisplay" />
                    <MenuColumn title="File Storage And Archiving" :items="shopMenu.fileStorage" />
                    <MenuColumn title="Office Basics And Stationery" :items="shopMenu.officeBasics" />
                    <div class="mega-col col-md-3">
                      <img src="/img/menu-1.jpg" alt="Menu Banner" class="img-fluid" />
                    </div>
                  </div>
                </div> -->
              </li>

              <li class="nav-item">
                <NuxtLink to="/contact-us" class="nav-link has-category" @click="$emit('close')">
                  <span class="menu-title">Contact</span>
                </NuxtLink>
              </li>
      
              <!-- Product Dropdown -->
              <!-- <li class="nav-item dropdown">
                <NuxtLink to="/6-accessories" class="nav-link dropdown-toggle has-category">
                  <span class="menu-title">Product</span>
                </NuxtLink>
                <div class="dropdown-menu wide-menu">
                  <div class="row">
                    <MenuColumn title="Writing Supplies" :items="productMenu.writingSupplies" />
                    <div class="mega-col col-md-6">
                      <img src="/img/menu-2.jpg" alt="Menu Banner" class="img-fluid" />
                    </div>
                  </div>
                </div>
              </li> -->
      
              <!-- Pages Dropdown -->
              <!-- <li class="nav-item dropdown">
                <NuxtLink to="/content/4-about-us" class="nav-link dropdown-toggle has-category">
                  <span class="menu-title">Pages</span>
                </NuxtLink>
                <div class="dropdown-menu">
                  <div class="row">
                    <MenuColumn title="Product list style" :items="pagesMenu.productList" />
                    <MenuColumn title="Product Page Styles" :items="pagesMenu.productPage" />
                  </div>
                </div>
              </li> -->
      
              <!-- Blogs -->
              <!-- <li class="nav-item">
                <NuxtLink to="/blog.html" class="nav-link has-category">
                  <span class="menu-title">Blogs</span>
                </NuxtLink>
              </li> -->
      
              <!-- Contact -->
              <!-- <li class="nav-item">
                <NuxtLink to="/contact-us" class="nav-link has-category">
                  <span class="menu-title">Contact</span>
                </NuxtLink>
              </li> -->
            </ul>
          </nav>
        </section>
    <!-- </div> -->
</template>

<script setup>
const shopMenu = {
  boardAndDisplay: [
    'Whiteboards',
    'Combination Boards',
    'Notice Boards',
    'Clipboards',
    'Wall Planners',
    'Cue Cards',
    'Display Boards',
    'Easels And Flipcharts',
    'Literature Holders',
    'Pin Boards',
    'Frames',
    'Presentation Accessories',
    'Sign Holders',
    'Whiteboard Cleaners And Accessories',
    'Chalk Boards And Accessories'
  ],
  fileStorage: [
    'Lever Arch Files And Ring Binders',
    'Dividers',
    'Square Cut And Manilla Folders',
    'Box Files',
    'Document Wallets',
    'Card Index And Supplies',
    'Clip Files And Folders',
    'Plastic Wallets And Folders',
    'Report Covers',
    'Storage Boxes',
    'Suspension Filing'
  ],
  officeBasics: [
    'Hole Punches',
    'Glues And Adhesives',
    'Post-It And Sticky Products',
    'Ink Stamps',
    'Name Badges And Accessories',
    'Scissors',
    'Calculators',
    'Office Clips And Fasteners',
    'Staplers And Staples',
    'Paper Trimmers And Cutters',
    'Cash Boxes And Cash Drawers',
    'Rulers',
    'Storage Boxes',
    'Adhesive Tape'
  ]
}

const productMenu = {
  writingSupplies: [
    'Ballpoint Pens',
    'Marker Pens',
    'Fineliners',
    'Pencils',
    'Fountain Pens',
    'Gel Pens',
    'Rollerball Pens',
    'Pen Refills',
    'Pencil Cases',
    'Correction',
    'Rubbers And Erasers',
    'Stationery Sets',
    'Writing Accessories'
  ]
}

const pagesMenu = {
  productList: Array.from({ length: 12 }, (_, i) => `Product list style ${i + 1}`),
  productPage: [
    'Product thumbs bottom',
    'Product thumbs left',
    'Product thumbs right',
    'Product no thumbs',
    'Product no thumbs center',
    'Product no thumbs fullwidth',
    'Product Gallery'
  ]
}
</script>
